import Playing from "@/Icons/Playing";
import { cx } from "@/utils";

import styles from "./PlayingAnimated.module.css";

type PlayingAnimatedProps = React.SVGProps<SVGSVGElement> & {
  className?: string;
};

const PlayingAnimated: React.FC<PlayingAnimatedProps> = ({
  className,
  ...props
}) => <Playing className={cx(styles.root, className)} {...props} />;

export default PlayingAnimated;
